import * as yup from 'yup';
import emailValidator from '@hero/validators/email';
const suppressionEmailSchema = yup
    .object()
    .shape({
    email: yup.lazy((val) => !val ? yup.string().trim().required('Email address is required') : emailValidator)
})
    .defined();
export default suppressionEmailSchema;
